// extracted by mini-css-extract-plugin
export default {"BrandsFilterSort":"BrandsFilterSort_BrandsFilterSort__xjITp","button":"BrandsFilterSort_button__vlvGD"};